import cn from 'classnames'
import { ComponentPropsWithoutRef, FC, memo } from 'react'

import styles from './IntegrationsPageLayout.module.scss'

import Text from '~shared/ui/Text'

interface IntegrationsPageLayoutProps extends ComponentPropsWithoutRef<'div'> {
  heading?: string
  subheading?: string
  description?: string | JSX.Element
}

const IntegrationsPageLayout: FC<React.PropsWithChildren<IntegrationsPageLayoutProps>> = ({
  heading,
  subheading,
  description,
  children,
  className,
  ...props
}) => {
  return (
    <div className={cn(styles.root, className)} {...props}>
      {heading && (
        <Text as="h1" textType="heading-md" className="mb-4">
          {heading}
        </Text>
      )}

      {subheading && (
        <Text as="span" textType="heading-sm" className="mb-5">
          {subheading}
        </Text>
      )}

      {description && (
        <Text as="p" type="body-m" textAlign="center" className="mb-2">
          {description}
        </Text>
      )}

      {children}
    </div>
  )
}

export default memo(IntegrationsPageLayout)
